import { useSDUIFilterablePaginatedSectionFilters } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Filters/useSDUIFilterablePaginatedSectionFilters";
import { useSDUIFilterablePaginatedSectionState } from "@faire/deprecated-retailer-visitor-shared/components/SDUI/SectionRenderers/FilterablePaginatedSection/__internal__/Filters/useSDUIFilterablePaginatedSectionState";
import { returnRetrievalRankingDebugInfo } from "@faire/deprecated-retailer-visitor-shared/search/loggedInBrandLeanProductTilesRequest";
import { getUser } from "@faire/deprecated-retailer-visitor-shared/serialized-data/getUser";
import { getSettingShouldDisplayRetrievalAndRankingDebugInfo } from "@faire/deprecated-retailer-visitor-shared/settings/getSettingShouldDisplayRetrievalAndRankingDebugInfo";
import { IFilterablePaginatedSection } from "@faire/web-api--source/indigofair/data/IFilterablePaginatedSection";
import { IGetSDUIFilteredComponentsRequest } from "@faire/web-api--source/indigofair/data/IGetSDUIFilteredComponentsRequest";
import { IPaginationData } from "@faire/web-api--source/indigofair/data/IPaginationData";

export const useSDUIFilteredComponentsRequest = (
  filterablePaginatedSection: IFilterablePaginatedSection
) => {
  const { oneIndexedPageNumber } = useSDUIFilterablePaginatedSectionState();
  const filterKeys = useSDUIFilterablePaginatedSectionFilters();
  const user = getUser();
  const filteredComponentsRequest =
    filterablePaginatedSection.get_s_d_u_i_filtered_components;
  const shouldRequestDebugInfo = returnRetrievalRankingDebugInfo(
    user,
    getSettingShouldDisplayRetrievalAndRankingDebugInfo()
  );

  return IGetSDUIFilteredComponentsRequest.build({
    page_identifier: filteredComponentsRequest?.page_identifier,
    filter_keys: filterKeys,
    pagination_data: IPaginationData.build({
      page_size: filteredComponentsRequest?.pagination_data?.page_size,
      page_number: oneIndexedPageNumber,
    }),
    enable_f_p_s_flow_layout:
      !!filteredComponentsRequest?.enable_f_p_s_flow_layout,
    ...(shouldRequestDebugInfo
      ? { return_debug_info: shouldRequestDebugInfo }
      : undefined),
  });
};
